module.exports = __webpack_public_path__ + "img/CATANZARO.70292d0f.png";